// client/src/pages/seo/seoLangConfig.js

export const SEO_LANGS = ["de", "en", "no"];

export const SEO_FALLBACK_LANG = "de";

export function isSeoLangReady(lang) {
  return SEO_LANGS.includes(String(lang || "").toLowerCase());
}

export function getSeoLangLinks(langLinks = {}) {
  return Object.fromEntries(
    Object.entries(langLinks).filter(([lang, path]) => {
      return SEO_LANGS.includes(lang) && typeof path === "string" && path;
    })
  );
}